var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"v-exclusive"},[_c('van-nav-bar',{attrs:{"title":"会员专享","left-arrow":"","fixed":"","border":false,"placeholder":true},on:{"click-left":_vm.onClickLeft}}),_c('VipMain')],1)}
var staticRenderFns = []

export { render, staticRenderFns }